import CategoriesList from '../components/Categories/CategoriesList';

export default function CategoriesListPage() {
  return <CategoriesList />;
}
